// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"41147be4","877":"41147be4"}[chunkId] + ".chunk.css";
};